import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import logoCalfImage from 'assets/img/logo_calf.png';

const CALF_GREEN      = '#8ebf63';
const CALF_GREEN_DIG  = '#39a82d';
const CALF_BLACK      = '#161616';
const CALF_LIGHT      = '#bee59a';

const calfInputSx = {
  mb: 2,
  '& .MuiOutlinedInput-root': {
    color: CALF_BLACK,
    borderRadius: 2,
    backgroundColor: '#f7f7f7',
    '& fieldset': { borderColor: 'rgba(0,0,0,0.15)' },
    '&:hover fieldset': { borderColor: CALF_GREEN },
    '&.Mui-focused fieldset': { borderColor: CALF_GREEN },
  },
  '& .MuiInputLabel-root': { color: 'rgba(0,0,0,0.45)' },
  '& .MuiInputLabel-root.Mui-focused': { color: CALF_GREEN_DIG },
};

function SignIn() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const history = useHistory();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleLogin = async () => {
    if (!executeRecaptcha) {
      console.log("Execute recaptcha not yet available");
      //return;
    }

    const token = await executeRecaptcha('login');
    setRecaptchaToken(token);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/login`, {
        usr_codigo: username,
        usr_clave: password,
        recaptchaToken: token,
      });
      //console.log('Token:', response.data.token);
      localStorage.setItem('token', 'Bearer '+ response.data.token);
      localStorage.setItem('usuario', response.data.usr_codigo);
      localStorage.setItem('nombre', response.data.usr_descripcion);
      localStorage.setItem('cambio', response.data.usr_cambiar);

      let cambioclave = response.data.usr_cambiar;
      //console.log('cambiar clave :', cambioclave);
      if (cambioclave === 'S'){
        history.push('/auth/cambio');
      }
      else{
        //console.log('guardo token');
        history.push('/admin');
        window.location.reload();
      }

    } catch (err) {
      // Manejar el error de autenticación
      console.error('Error de autenticación:', err.message);
      setError('Credenciales inválidas');
      setShowErrorAlert(true);
      setTimeout(() => {
        setShowErrorAlert(false);
      }, 1000);
    }
  };
  const onVerifyRecaptcha = (token) => {
    setRecaptchaToken(token);
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex' }}>

      {/* IZQUIERDA — branding */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: '45%',
          backgroundColor: CALF_GREEN,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={logoCalfImage}
          alt="CALF"
          style={{ width: 280, height: 'auto', filter: 'brightness(0) invert(1)' }}
        />
        <Typography
          sx={{
            fontFamily: "'Nohemi', Arial, sans-serif",
            fontWeight: 700,
            fontSize: '3rem',
            color: '#ffffff',
            mt: 2,
            letterSpacing: 6,
          }}
        >
          
        </Typography>
        <Typography
          sx={{
            fontFamily: "'Nohemi', Arial, sans-serif",
            fontWeight: 300,
            fontSize: '0.9rem',
            color: 'rgba(255,255,255,0.8)',
            letterSpacing: 3,
            textTransform: 'uppercase',
            mt: 1,
          }}
        >
          Dashboard
        </Typography>
        <Box sx={{ width: 60, height: 3, bgcolor: '#fff', borderRadius: 2, mt: 3, opacity: 0.6 }} />
      </Box>

      {/* DERECHA — formulario */}
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', p: 4 }}>
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            maxWidth: 400,
            backgroundColor: 'transparent',
            borderRadius: 3,
            p: 4,
          }}
        >
          <Box sx={{
            display: { xs: 'flex', md: 'none' },
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: CALF_GREEN,
            borderRadius: 2,
            p: 2,
            mb: 4,
            mx: 'auto',
            width: 'fit-content',
          }}>
            <img
              src={logoCalfImage}
              alt="CALF"
              style={{ width: 160, height: 'auto', filter: 'brightness(0) invert(1)' }}
            />
          </Box>

          <Typography
            sx={{
              fontFamily: "'Nohemi', Arial, sans-serif",
              fontWeight: 600,
              fontSize: '1.8rem',
              color: CALF_BLACK,
              mb: 1,
            }}
          >
            Bienvenido
          </Typography>
          <Typography
            sx={{
              color: 'rgba(0,0,0,0.45)',
              fontSize: '0.85rem',
              mb: 4,
            }}
          >
            Ingresá tus credenciales
          </Typography>

          <TextField
            label="Usuario"
            fullWidth
            sx={calfInputSx}
            value={username}
            onChange={(e) => setUsername(e.target.value.toLowerCase())}
            inputProps={{ autoCapitalize: 'none', autoCorrect: 'off' }}
          />
          <TextField
            label="Contraseña"
            type="password"
            fullWidth
            sx={{ ...calfInputSx, mb: 3 }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            fullWidth
            variant="contained"
            onClick={handleLogin}
            sx={{
              backgroundColor: CALF_GREEN,
              color: '#ffffff',
              fontFamily: "'Nohemi', Arial, sans-serif",
              fontWeight: 700,
              fontSize: '0.9rem',
              letterSpacing: 1,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'uppercase',
              mt: 1,
              boxShadow: 'none',
              '&:hover': { backgroundColor: CALF_GREEN_DIG, boxShadow: 'none' },
            }}
          >
            INGRESAR
          </Button>

          <Collapse in={showErrorAlert}>
            <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>
              Credenciales invalidas
            </Alert>
          </Collapse>
        </Paper>
      </Box>
    </Box>
  );
}

export default SignIn;
